import React from "react";
import { Launch, ContentCopy, DeleteOutline, PencilOutline } from "mdi-material-ui";
import locale, { toLocale } from "@bonliva-crm/locale";
import { clipboard, openBlank } from "@clientUtils";
import { UserAvatarChip } from "@containers/UserAvatarChip";
import { Body, PlainLink, SimpleIconButton, WithTooltip } from "@components";
import WithPopover from "@components/WithPopover";
import { Subheading } from "@components/typography/Subheading";
import { TableSearchColumn } from "@search/TableSearch";
import { SharedFileSearchStore } from "./SharedFileSearchStore";
import { Row } from "./utils";

export const getColumns = (
  store: SharedFileSearchStore
): Array<TableSearchColumn<Row>> => [
  {
    label: "",
    dataKey: "shareURL",
    width: 36,
    cellRenderer: (data) => (
      <WithTooltip title={locale.CopyUrl}>
        <SimpleIconButton onClick={() => clipboard(data.rowData.ShareURL)}>
          <ContentCopy fontSize="small" />
        </SimpleIconButton>
      </WithTooltip>
    )
  },
  {
    label: "",
    dataKey: "copyUrl",
    width: 36,
    cellRenderer: ({ rowData }) => (
      <WithTooltip title={locale["Open in a new tab"]}>
        <SimpleIconButton
          // href={rowData.ShareURL}
          onClick={(e) => {
            e.preventDefault();
            openBlank(rowData.ShareURL);
          }}
        >
          <Launch fontSize="small" />
        </SimpleIconButton>
      </WithTooltip>
    )
  },
  {
    label: locale.FileName,
    dataKey: "FileRef",
    style: { minWidth: 125 },
    cellRenderer: ({ rowData }) => <Body>{rowData.FileRef.Name}</Body>
  },
  {
    width: 200,
    label: locale.SharedBy,
    dataKey: "SharedBy",
    cellRenderer: ({ rowData }) => (
      <div>
        <UserAvatarChip userName={rowData.SharedBy.Name} size="small" />
      </div>
    )
  },
  {
    width: 100,
    label: locale.Accessed,
    dataKey: "FileStats",
    cellRenderer: (data) => {
      return (
        <WithPopover
          popoverContent={
            <Body>
              <Subheading>{data.rowData.FileRef.Name}</Subheading>
              <br />
              Åtkomst sedan:
              <br />
              {data.rowData.FileStats.AccessRecords.map((item, idx) => {
                return <div key={idx}>{toLocale.dateTime(item.AccessedOn)}</div>;
              })}
            </Body>
          }
          PopoverProps={{
            anchorOrigin: { horizontal: "left", vertical: "bottom" },
            transformOrigin: { horizontal: "left", vertical: "top" }
          }}
        >
          <PlainLink dashed>{data.cellData?.AccessedTotal} antal</PlainLink>
        </WithPopover>
      );
    }
  },
  {
    width: 160,
    label: locale.From,
    dataKey: "SharedOn",
    cellRenderer: (data) => {
      return <Body>{toLocale.dateTime(data.rowData.SharedOn)}</Body>;
    }
  },
  {
    width: 160,
    label: locale.To,
    dataKey: "ExpiresOn",
    cellRenderer: (data) => {
      return <Body>{toLocale.dateTime(data.rowData.ExpiresOn)}</Body>;
    }
  },
  {
    width: 36,
    label: "",
    dataKey: "edit",
    cellRenderer: (data) => {
      return (
        <WithTooltip title={locale["Edit file"]}>
          <SimpleIconButton
            onClick={() => {
              store.edit(data.rowData.FileRef.NodeID, data.rowIndex);
            }}
          >
            <PencilOutline fontSize="small" />
          </SimpleIconButton>
        </WithTooltip>
      );
    }
  },
  {
    width: 36,
    label: "",
    dataKey: "delete",
    cellRenderer: (data) => {
      return (
        <WithTooltip title={locale.Delete}>
          <SimpleIconButton
            onClick={() => {
              store.deleteFile(data.rowData.FileRef.NodeID, data.rowIndex);
            }}
          >
            <DeleteOutline fontSize="small" />
          </SimpleIconButton>
        </WithTooltip>
      );
    }
  }
];
